import { SecurityAudit } from 'src/app/modules/portfolio/models/security-audit';
import { SecurityAuditHistoryResponse } from 'src/app/web-api-client';

export const mapSecurityAuditHistoryResponseFromResponseNested = (
  response: SecurityAuditHistoryResponse
): SecurityAudit => ({
  securityId: response.security?.securityId,
  clientName: response.security?.entity?.client?.name,
  transactionTypeName: response.security?.transactionType?.name,
  entityTypeName: response.security?.entity?.entityType?.name,
  securityTypeName: response.security?.securityType?.name,
  investmentJurisdictionName:
    response.security?.investmentJurisdiction?.country?.name,
  modified: response?.modified,
  description: response.description,
  userName: response.createdBy ? response.createdBy.split('|').pop() : '',
});
